import {NewSignButton} from "./NewSignButton";
import {apiConstants} from "../../constants/ApiConstants";

export let SignMosOfferContainer = NewSignButton(apiConstants.API_URL + "/offer/sign");
export let SignMosContractContainer = NewSignButton(apiConstants.API_URL + "/contract/sign");
export let SignMosregContractContainer = NewSignButton(apiConstants.API_URL + "/mo/contract/sign");
export let SignMosExecutionContainer = NewSignButton(apiConstants.API_URL + "/execution/sign");